{
  "name": "@ns/public-ledger-buy-credits",
  "version": "1.1.0",
  "description": "Buy nodeStream credits for the company's public ledger account: choose an amount (at least 10,000 credits) at a price held for 30 minutes, and pay by card. The server completes the job paid once Stripe confirms the payment (public-ledger-credits-pay, public-ledger-credits-payment-return or the stripe-payment-intent-succeeded webhook).",
  "inputs": {},
  "outcomes": {
    "paid": {
      "serverOnly": true,
      "inputs": {
        "purchaseId": {
          "type": "string",
          "ref": "plCreditPurchase"
        },
        "payerId": {
          "type": "string",
          "ref": "people"
        }
      }
    }
  }
}
